import _ from "lodash";
import store from "@/store";

// TODO: someday, this will probably need to be retrieved from the database

const TS_DEVICE_TYPE = 0;
const RSU_DEVICE_TYPE = 1;
const TSC_DEVICE_TYPE = 2;
const ESS_DEVICE_TYPE = 3;

console.warn(
	"The `device-types` module has been deprecated and is no longer reliable or guaranteed to have correct data. If you need access to the same data, please see the `device-manager` Vuex store module."
);

const initialDeviceTypes = {
	3: {
		shortName: "ESS",
		name: "Environmental Sensor Station",
		icon: "fa-cloud",
		disabled: false
	},
	4: {
		shortName: "NWS",
		name: "National Weather Station",
		icon: "fa-cloud",
		disabled: true
	},
	5: {
		shortName: "SPL",
		name: "Snowplows",
		icon: "fa-snowflake",
		disabled: true
	},
	6: {
		shortName: "NEC",
		name: "Network Edge Computing",
		icon: "fa-microchip",
		disabled: true
	},
	// 7: {
	// 	shortName: "ESS",
	// 	name: "Environmental Sensor Station",
	// 	icon: "fa-sun",
	// 	disabled: false
	// },
	8: {
		shortName: "DMS",
		name: "Dynamic Message Sign",
		icon: "fa-sign",
		disabled: true
	},
	9: {
		shortName: "CCTV",
		name: "Closed-Circuit TV",
		icon: "fa-video",
		disabled: true
	},
	10: {
		shortName: "VDS",
		name: "Vehicle Detection Station",
		icon: "fa-car",
		disabled: true
	},
	11: {
		shortName: "WIM",
		name: "Weigh in Motion",
		icon: "fa-weight",
		disabled: true
	},
	12: {
		shortName: "OBU",
		name: "On-Board Unit",
		icon: "fa-assistive-listening-systems",
		disabled: true
	},
	13: {
		shortName: "FVU",
		name: "Field Verification Unit",
		icon: "fa-clipboard-check"
	},
	14: {
		shortName: "RWIS",
		name: "Road Weather Information Service?",
		disabled: true,
		icon: "fa-cloud"
	},
	15: {
		shortName: "TFMP",
		name: "TFM Mobile Platform",
		icon: "fa-upload",
		disabled: true
	}
};

// initialDeviceTypes[TS_DEVICE_TYPE] = {
// 	shortName: "TS",
// 	name: "Total Station",
// 	icon: "fa-wifi",
// 	isAddable: false,
// 	moduleName: "ts"
// };

initialDeviceTypes[RSU_DEVICE_TYPE] = {
	shortName: "RSU",
	name: "Roadside Unit",
	icon: "fa-broadcast-tower",
	isAddable: true,
	moduleName: "rsu"
};

initialDeviceTypes[TSC_DEVICE_TYPE] = {
	shortName: "TSC",
	name: "Traffic Signal Controller",
	icon: "fa-traffic-light",
	isAddable: true,
	moduleName: "tsc"
};

initialDeviceTypes[ESS_DEVICE_TYPE] = {
	shortName: "ESS",
	name: "Environmental Sensor Station",
	icon: "fa-cloud",
	isAddable: true,
	moduleName: "ess"
};

const deviceTypes = _.mapValues(initialDeviceTypes, dt =>
	Object.assign({}, dt, {
		moduleName: dt.moduleName || dt.shortName.toLowerCase()
	})
);

function deviceTypeModuleName(deviceTypeId) {
	const d = deviceTypes[deviceTypeId];
	if (!d) return false;
	return d.moduleName || d.shortName.toLowerCase();
}

function deviceTypeModule(deviceTypeId) {
	const d = deviceTypes[deviceTypeId];
	if (!d) return false;
	return store._modules.root._children[deviceTypeModuleName(deviceTypeId)];
}

function doesDeviceHaveModule(deviceTypeId) {
	return !!deviceTypeModule(deviceTypeId);
}

export {
	TS_DEVICE_TYPE,
	RSU_DEVICE_TYPE,
	TSC_DEVICE_TYPE,
	ESS_DEVICE_TYPE,
	deviceTypeModuleName,
	deviceTypeModule,
	doesDeviceHaveModule,
	deviceTypes
};
export default deviceTypes;
